import TopNav from '@/components/top-nav';
import TopInfoBar from '@/components/TopInfoBar';
import DesktopFooter from '@/app-components/desktop/desktop-footer';
import { useFirebaseAuth } from '@/contexts/FirebaseAuthContext';
import { useLocation } from 'react-router';

const DesktopLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { user, loading } = useFirebaseAuth();

  const showNavigation = pathname !== '/login' && !loading && !!user;

  return (
    <div className='w-full min-h-screen bg-gray-50 flex flex-col'>
      {showNavigation && (
        <>
          <TopInfoBar />
          <TopNav />
        </>
      )}
      <main className='flex-1 overflow-y-auto'>
        {children}
      </main>
      {showNavigation && <DesktopFooter />}
    </div>
  );
};

export default DesktopLayout;
